const FALLBACK_LANGUAGES = ['en', 'ar'];

/**
 * Returns a non-empty string from value, or null when missing/empty.
 */
const pickNonEmptyString = (value) => {
    if (typeof value !== 'string') {
        return null;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
};

/**
 * Resolves a localized field for the requested language.
 * Supports legacy plain strings and new { en, ar, ... } objects.
 *
 * Fallback order: requested language → english → arabic → ""
 */
const getLocalizedValue = (field, lang = 'en') => {
    if (field === undefined || field === null) {
        return '';
    }

    if (typeof field === 'string') {
        return field;
    }

    if (typeof field !== 'object' || Array.isArray(field)) {
        return '';
    }

    const normalizedLang = typeof lang === 'string' ? lang.toLowerCase() : 'en';
    const languagesToTry = [
        normalizedLang,
        ...FALLBACK_LANGUAGES.filter((code) => code !== normalizedLang),
    ];

    for (const languageCode of languagesToTry) {
        const resolved = pickNonEmptyString(field[languageCode]);
        if (resolved !== null) {
            return resolved;
        }
    }

    return '';
};

/**
 * Returns searchable plain text from legacy strings or localized objects.
 * Combines all supported language values for filters/search.
 */
const getSearchableLocalizedText = (field) => {
    if (field === undefined || field === null) {
        return '';
    }

    if (typeof field === 'string') {
        return field;
    }

    if (typeof field !== 'object' || Array.isArray(field)) {
        return '';
    }

    return FALLBACK_LANGUAGES
        .map((languageCode) => pickNonEmptyString(field[languageCode]))
        .filter((value) => value !== null)
        .join(' ');
};

export { getSearchableLocalizedText };
export default getLocalizedValue;
